// material-ui
import { Box } from '@mui/material';
import Profile from './Profile';

// ==============================|| HEADER - CONTENT ||============================== //

const HeaderContent: React.FC = (): JSX.Element => {
    return (
        <>
            <Box sx={{ width: '100%', ml: 1 }} />
            <Profile />
        </>
    );
};

export default HeaderContent;
